
import { Component, Prop, Vue } from "vue-property-decorator";

export class DescribeData {
  label = "";
  text = "";
  color = "";
  desc = "";
}
@Component({})
export default class Describe extends Vue {
  connectCode = "";
  @Prop({ default: () => new DescribeData() })
  describe!: DescribeData;
}
